import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import { Context, AddLessonSchema, Transitions } from "../../../types"
import {
  getLessonsTransition,
  getPlanAvailableItemsTransition,
  undoTransition
} from "./transitionalStates"

export const addLessonDrawerState: StateNodeConfig<
  Context,
  AddLessonSchema,
  Transitions,
  BaseActionObject
> = {
  /*
  add_lesson state happens when the user clicks a section to add mastery lessons or practice test
  */
  entry: assign<Context>((ctx, _evt) => ({
    addLessonModal: true,
    expanded: [...ctx.expanded, ctx.selectedSectionId]
  })),
  initial: "loading",
  states: {
    loading: {
      always: [
        {
          target: "get_plan_available_items_transition",
          // If it's published plan, use plan available items,
          // otherwise use section items
          cond: ctx => !!ctx.publishedStudyPlan && !ctx.studyPlan
        },
        { target: "get_lessons_transition" }
      ]
    },
    //// TODO: we don't have this update?
    //// Section item's only property is teachLive.
    //// teachLive is updated through toggle teach live already.
    // update_section_item_transition: {
    //   invoke: {
    //     src: "updateSectionItem",
    //     onDone: {
    //       target: "idle",
    //       actions: assign({
    //         studyPlan: (_ctx, evt) => evt.data.plan
    //       })
    //     },
    //     onError: {
    //       // TODO: handle error
    //       // target: "idle",
    //       // actions: assign({ errorMessage: (_ctx, evt) => evt.data.message })
    //     }
    //   }
    // },
    idle: {
      on: {
        FILTER: {
          actions: "filterLessonOptions"
        },
        SORT: {
          actions: "sortLessonOptions"
        },
        ADD_LESSON: {
          target: "#StudyPlan.add_lesson_transition"
          //cond: "checkIfLessonAdded" // unless we do this in the function addLessonToPlan
        },
        REMOVE_LESSON: {
          target: "#StudyPlan.remove_lesson_transition"
        },
        REPLACE_LESSON: {
          target: "#StudyPlan.replace_lesson_transition",
          cond: ctx =>
            ctx.studyPlan.sections.find(s => s.id === ctx.selectedSectionId)
              ?.type === "PRACTICE_TEST"
        },
        PREVIEW: {
          target: "#StudyPlan.get_lesson_preview_transition"
        },
        UNDO: {
          target: "undo_transition"
        }
      }
    },
    get_lessons_transition: { ...getLessonsTransition },
    get_plan_available_items_transition: { ...getPlanAvailableItemsTransition },
    undo_transition: { ...undoTransition }
  },
  on: {
    VIEW_DETAILS: {
      target: "lesson_detail_view",
      actions: assign((_ctx, { lessonId }) => ({
        selectedLessonId: lessonId,
        lessonDetailViewModal: true
      }))
    },
    CLOSE: [
      {
        target: "#StudyPlan.edit_plan.remove_section_transition",
        actions: assign((_ctx, _evt) => ({
          addLessonModal: false,
          lessonOptions: []
        })),
        cond: (ctx, _evt) => {
          const currentSection = ctx.studyPlan?.sections?.find(
            section => section.id === ctx.selectedSectionId
          )
          return (
            ctx.previousParentState === "edit_plan" &&
            currentSection &&
            !currentSection.items?.length
          )
        }
      },
      {
        target: "idle",
        actions: assign((_ctx, _evt) => ({
          selectedSectionId: null,
          addLessonModal: false,
          lessonOptions: []
        }))
      }
    ]
  }
}
